import { R_AND_I_ENABLED } from 'constants/feature-flags'
import { invert } from 'libraries/lodash'
import { AOLType } from 'types/AOL'

export const AOL_CORPORATE = 'corporate'
export const AOL_EMPLOYMENT = 'employment'
export const AOL_RI = 'ri'

export const ALL_AOLS = R_AND_I_ENABLED
  ? [
      AOL_CORPORATE,
      AOL_EMPLOYMENT,
      AOL_RI
    ]
  : [
      AOL_CORPORATE,
      AOL_EMPLOYMENT
    ]

export const AOL_DISPLAY_NAMES: { [key in AOLType]: string } = {
  corporate: 'Corporate',
  employment: 'Employment',
  ri: 'R&I'
}

// Reverse of AOL_DISPLAY_NAMES - for mapping a backend-supplied display
// label (e.g. an "available" facet option name like "R&I") back to its aol
// code ('ri'), where the two aren't related by a simple case change.
export const AOL_CODE_BY_DISPLAY_NAME: Record<string, AOLType> = invert(AOL_DISPLAY_NAMES) as Record<string, AOLType>

export const DEFAULT_AOL_ORDER = R_AND_I_ENABLED
  ? [
      AOL_CORPORATE,
      AOL_EMPLOYMENT,
      AOL_RI
    ]
  : [
      AOL_CORPORATE,
      AOL_EMPLOYMENT
    ]

// Practising Areas
export const PRACTISING_AOL_OTHER = 'other'

export const PRACTICE_AREAS = [
  'banking-finance',
  'commercial-litigation',
  'company-commercial',
  'construction',
  'competition',
  'corporate',
  'criminal',
  'dispute-resolution',
  'employment',
  'environmental',
  'family',
  'financial-services-regulation',
  'immigration',
  'insurance',
  'ipr',
  'pensions',
  'private-client',
  'property-real-estate',
  'restructuring-insolvency',
  'tax-private-client',
  'tax-company-business',
  'wills-probate'
]

export const PRACTICE_AREAS_DISPLAY_NAMES: { [key: string]: string } = {
  'banking-finance': 'Banking & Finance',
  'commercial-litigation': 'Commercial Litigation',
  'company-commercial': 'Company/Commercial',
  construction: 'Construction',
  competition: 'Competition',
  corporate: 'Corporate',
  criminal: 'Criminal',
  'dispute-resolution': 'Dispute Resolution',
  employment: 'Employment',
  environmental: 'Environmental',
  family: 'Family',
  'financial-services-regulation': 'Financial Services and Regulation',
  immigration: 'Immigration',
  insurance: 'Insurance',
  ipr: 'IPR',
  pensions: 'Pensions',
  'private-client': 'Private Client',
  'property-real-estate': 'Property/Real Estate',
  'restructuring-insolvency': 'Restructuring & Insolvency',
  'tax-private-client': 'Tax – Private Client',
  'tax-company-business': 'Tax – Company and Business',
  'wills-probate': 'Wills and Probate'
}
